module.exports = __webpack_public_path__ + "media/site/images/carousel_slides/carousel-slide-ecommerce-adc60f1c939f290bbf7acd6c393b7d1e.png";